import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { InHouseProvider } from "./context/inHousePermissions";
import { PresenceProvider } from "./context/Presence";
import { NotificationsProvider } from "./context/NotificationContext";
import AllRules from "./context/allRules";
import { ThemeProvider } from "./context/darkTheme";
import ProtectedRoute from "./context/protectedRoute";
import EditorRoute from "./context/protectedEditorRoute";

// Pages
import Login from "./routes/login";
import Notguest from "./routes/notguest";
import Main from "./routes/main";
import Sales from "./routes/sales";
import Refunds from "./routes/refunds";
import Transactions from "./routes/transactions";
import EditorNew from "./routes/editornew";
import EditPanelWrapper from "./components/EditPanelWrapper";
import Fullfilment from "./routes/fullfilment";
import PromoCodes from "./routes/promoCodes";
import Pulse from "./routes/pulse";
import Storage from "./routes/storage";
import Team from "./routes/team";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider>
  <AuthProvider>
    <InHouseProvider>
      <BrowserRouter>
        <PresenceProvider>
          <AllRules>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<Login />} />
              <Route path="/not-authorized" element={<Notguest />} />

              {/* Protected */}
              <Route path="/" element={<ProtectedRoute><Main /></ProtectedRoute>} />
              <Route path="/sales" element={<ProtectedRoute><Sales /></ProtectedRoute>} />
              <Route path="/refunds" element={<ProtectedRoute><Refunds /></ProtectedRoute>} />
              <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
              <Route path="/editor" element={<ProtectedRoute><EditorNew /></ProtectedRoute>} />
              <Route path="/editor/:username" element={<EditorRoute><EditPanelWrapper /></EditorRoute>} />
              {/* Один цех (Алматы): старые /log/:workshop и /storage/:workshop/… уводятся на общий вид. */}
              <Route path="/log" element={<ProtectedRoute><Fullfilment /></ProtectedRoute>} />
              <Route path="/log/:workshop" element={<Navigate to="/log" replace />} />
              <Route path="/promo-codes" element={<ProtectedRoute><PromoCodes /></ProtectedRoute>} />
              <Route path="/marketing" element={<Navigate to="/promo-codes" replace />} />
              <Route path="/pulse" element={<ProtectedRoute><Pulse /></ProtectedRoute>} />
              <Route path="/storage" element={<ProtectedRoute><Storage /></ProtectedRoute>} />
              <Route path="/storage/:day" element={<ProtectedRoute><Storage /></ProtectedRoute>} />
              <Route path="/storage/:day/:username" element={<ProtectedRoute><Storage /></ProtectedRoute>} />
              <Route path="/storage/:workshop/:day/:username" element={<ProtectedRoute><Storage /></ProtectedRoute>} />
              <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
            </Routes>
          </AllRules>
        </PresenceProvider>
      </BrowserRouter>
    </InHouseProvider>
  </AuthProvider>
  </ThemeProvider>
);
